import { getSrcWithParams } from './getSrcWithParams';
export const getSrcSetFromWidths = (src, widths, aspect, options = { crop: false, webp: false }) => {
    const l = [];
    for (let w of widths) {
        l.push(getSrcWithParams(w, aspect, src, true, options));
    }
    return l.join(', ');
};
//# sourceMappingURL=getSrcSetFromWidths.js.map